var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInkVaultTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 461 170.5",
    style: {
      enableBackground: "new 0 0 461 170.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#009BCE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,15.5c7,3.3,14.1,6.9,21.1,10.8c-1.3,31.3-2.6,62.7-3.9,93.9c-7-2.9-14.1-6-21-9.3 C31.6,79.1,32.8,47.3,34.1,15.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.9,54.6c6.7,0.8,13.2,1.7,19.9,2.5c-0.3,4.8-0.5,9.7-0.7,14.5c0.6-1.3,6.8-15.1,22.8-13.8 c12.9,1.1,17.4,11,16.8,29.3c-0.6,17.8-1.1,35.7-1.8,53.5c-6.8-1.7-13.5-3.4-20.2-5.5c0.6-23.4,0.6-23.6,1.4-44.9 c0.2-5.5-2.3-11.3-6.8-12.1C86.2,76.9,80.6,81.3,80,96c-0.5,10.9-0.8,21.8-1.3,32.6c-6.7-2.3-13.2-4.8-19.8-7.4 C60.1,99.1,61,76.8,61.9,54.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.1,60.6c6.7,0.5,13.3,0.9,20,1.4c-0.3,11.6-0.6,23.1-0.9,34.7c0.7,0.1,1.6,0.2,2.3,0.3 c5-10.7,10-21.6,14.9-32.8c7.4,0.4,14.8,0.6,22.2,0.9c-6.1,14.4-12.2,28.6-18.5,42.4c7,15.1,14.1,30.3,21.4,45.6 c-8-0.6-16-1.6-23.9-2.7c-5.6-12.4-11.3-24.6-16.8-36.7c-0.6-0.1-1.2-0.2-1.8-0.3c-0.3,11.6-0.6,23-0.9,34.6 c-6.8-1.3-13.6-2.7-20.3-4.3C128.5,115.9,129.3,88.2,130.1,60.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.8,32.2c5.9,0.1,12,0.1,17.9,0.2c4.8,29,9.8,58,14.9,87.1c5.6-29,11.2-58,16.6-87c5.9,0,12-0.1,17.9-0.1 c-7.4,41-15.2,82.6-23.2,123.9c-7.7,0.1-15.5,0-23.3-0.3C207.5,114.5,200.6,73.1,193.8,32.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.7,140.7c0,0.3,0,0.5,0,0.8c-2.9,8.1-8.4,13.8-16.2,14.6c-11.3,1.1-19-9.7-19.1-26.4 c-0.1-17.1,7.3-28.2,18.4-28.9c8.3-0.5,13.5,2.9,16.3,9.3c-0.4-13.8-2.3-19.4-10.3-18.9c-4.3,0.3-10.5,2.5-19.2,5.9 c-0.1-7.6-0.2-15.2-0.3-22.9c0,0,9.8-3.6,21.6-4.2c2.3-0.1,4.8-0.1,7.2,0.1c16.8,1.1,17.8,23.7,18.1,40.9 c0.3,12.9,0.6,25.8,0.8,38.7c-5.6,1-11.3,2-17,2.8C290.9,147.5,290.8,143.7,290.7,140.7z M281.6,135.3c6-0.6,8.9-3.8,8.8-8.8 c-0.1-6.2-0.9-7.9-9-7.2c-6,0.5-9.1,3.6-9,8.8C272.4,133.3,275.6,135.9,281.6,135.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.8,135.7c-5.4,1.8-10.8,3.4-16.2,5c-0.1-2.7-0.2-5.4-0.3-8.1c-2,4.7-5.9,11.4-13.9,13.4 c-11,2.9-19-5.2-19.4-23.2c-0.4-17.7-0.8-35.5-1.2-53.3c5.4-0.4,10.8-0.9,16.1-1.5c0.8,23.6,0.8,23.8,1.4,45.3 c0.2,5.7,2,9.2,8.3,7.8c6-1.4,8-5.5,7.8-12.3c-0.5-14.2-0.9-28.4-1.4-42.6c5.3-0.6,10.7-1.3,16-2.1C363.1,88.2,364,112,364.8,135.7z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.1,40c5.9-0.3,11.8-0.7,17.7-1.1c1.2,29.7,2.4,59.3,3.6,89c-5.9,2.1-11.8,4-17.8,5.8 C369.5,102.5,368.3,71.3,367.1,40z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.3,71.5c-0.2-5-0.4-9.8-0.6-14.8c2.8-0.5,8.5-9.5,5.4-25.9c5.4-2.8,10.7-5.5,16.1-8.1 c0.4,10.1,0.9,20.2,1.2,30.3c3.6-1.5,7.3-3,10.9-4.5c0.2,4.3,0.3,8.5,0.5,12.7c-3.6,1.8-7.3,3.6-10.9,5.4c0.4,8.9,0.7,17.6,1.1,26.5 c0.2,5.9,3.3,6.6,6.9,5.1c2.4-1,5.1-2.8,7.4-4.5c0.2,4.6,0.4,9.3,0.6,13.8c-5.1,3.9-9.5,6.7-13.1,8.3c-13.2,6-17.9-2.7-18.6-18.5 c-0.1-1.6-0.7-15.8-1.1-27.1C398.2,70.8,396.3,71.1,394.3,71.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkVaultTextLogo);
export default __webpack_public_path__ + "static/media/InkVaultTextLogo.142f77bfe0e2618ba74629bcccf2787f.svg";
export { ForwardRef as ReactComponent };